import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import classNames from 'classnames'
import React, { useState } from 'react'
import { ActionOption, Avatar, ProfileContainer } from '../styled'

// Assets
import { getStatusChangeRamal } from 'api/user'
import AvatarEmpty from 'images/avatar-empty.jpg'
import { ReactComponent as Pencil } from 'images/icons/edit.svg'
import { ReactComponent as ExpandMore } from 'images/icons/expanse.svg'
import { ReactComponent as Help } from 'images/icons/help.svg'
import { ReactComponent as Palette } from 'images/icons/palette.svg'
import { ReactComponent as StatusChange } from 'images/icons/recall.svg'
import { toast } from 'react-hot-toast'
const Profile = props => {
	const { auth, t } = props

	const [open, setOpen] = useState(false)

	const handleChangeRamalStatus = () => {
		getStatusChangeRamal()
			.then(res => {
				toast.success('Status mobcall atualizado com sucesso!')
			})
			.catch(err => console.log(err))
	}

	return (
		<ClickAwayListener onClickAway={() => setOpen(false)}>
			<ProfileContainer>
				<button onClick={() => setOpen(prevState => !prevState)}>
					<Avatar>
						<img
							src={
								auth.photo && auth.photo.length > 0 ? auth.photo : AvatarEmpty
							}
							alt="Foto do usuario"
						/>
					</Avatar>

					<div className="info">
						<p>
							{t.hello}, {auth.name && auth.name.split(' ')[0]}
						</p>
						{auth.status !== 'pause' ? (
							props.available ? (
								<p>
									<span className="status online" />
									{t.online}
								</p>
							) : (
								<p>
									<span className="status unavailable" />
									Pausa canal
								</p>
							)
						) : (
							<p>
								<span className="status pause" />
								{t.pause}
							</p>
						)}
						{auth && auth.ramal_status && (
							<p>
								{' '}
								{auth.ramal_status === 'available' ? (
									<>
										<span className="status online" />
										Disponivel no discador{' '}
										{auth.ramal_type
											? auth.ramal_type === 'desktop'
												? 'no PC'
												: 'no celular'
											: ''}
									</>
								) : auth.ramal_status === 'logout' ? (
									<>
										<span className="status offline" />
										Deslogado no discador
									</>
								) : auth.ramal_status === 'paused' ? (
									<>
										<span className="status pause" />
										Discador pausado
									</>
								) : (
									<>
										<span className="status pause" />
										Em ligação
									</>
								)}
							</p>
						)}
					</div>
					<ExpandMore />
				</button>

				<ActionOption className={classNames({ hidden: !open })}>
					{auth?.ramal_status && (
						<button onClick={() => props.handleOpenPauseChannelDialog(true)}>
							<div className="status online" />
							Disponibilidade
						</button>
					)}
					{Array.isArray(props.breaks) && props.breaks.length > 0 && (
						<button onClick={() => props.handleOpenPauseDialog(true)}>
							<div className="status pause" />
							{t.pause}
						</button>
					)}
					{auth?.use_mobcall && (
						<button onClick={() => handleChangeRamalStatus()}>
							<StatusChange style={{ width: '10px', height: '10px' }} />
							Status mobcall
						</button>
					)}

					{(auth?.ramal_status ||
						(Array.isArray(props.breaks) && props.breaks.length > 0)) && (
						<span />
					)}

					<button onClick={() => props.handleOpenAppearanceDialog(true)}>
						<Palette />
						{t.editAppearance}
					</button>

					<button onClick={() => props.handleOpenProfileDialog(true)}>
						<Pencil />
						{t.editProfile}
					</button>

					<a
						href="https://docs.digitalk.com.br/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<Help />
						{t.help}
					</a>

					<span />

					<button onClick={() => props.logout(auth)}>
						<div className="status offline" />
						{t.logout}
					</button>
				</ActionOption>
			</ProfileContainer>
		</ClickAwayListener>
	)
}

Profile.defaultProps = {}
export default Profile
